import { MessageCircle, Phone } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND } from "@/lib/constants";

const StickyButtons = () => {
  const { t } = useLanguage();
  return (
    <div className="dx-float" data-testid="sticky-buttons">
      <a
        href={BRAND.whatsappLink}
        target="_blank"
        rel="noreferrer"
        aria-label={t.common.whatsapp}
        className="group w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1fbd59] text-white flex items-center justify-center shadow-2xl shadow-emerald-900/40 transition hover:scale-105"
        data-testid="sticky-whatsapp"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="sr-only">{t.common.whatsapp}</span>
      </a>
      <a
        href={BRAND.telLink}
        aria-label={t.common.call}
        className="sm:hidden w-14 h-14 rounded-full bg-[#e10600] hover:bg-[#c20500] text-white flex items-center justify-center shadow-2xl shadow-red-900/40 transition hover:scale-105"
        data-testid="sticky-call"
      >
        <Phone className="w-6 h-6" />
        <span className="sr-only">{t.common.call}</span>
      </a>
    </div>
  );
};

export default StickyButtons;
